export interface CourseData {
    name: string;
    code: string;
    slots: string[];
    credits: number;
    faculty: string;
    venue: string;
    type: string;
}

export const searchCourses = (
    query: string,
    allCourses: CourseData[],
    isSlotTaken: (slot: string) => boolean
): CourseData[] => {
    const lowerCaseQuery = query.toLowerCase();

    return allCourses.filter(course => {
        const hasConflict = course.slots.some(slot => isSlotTaken(slot));
        if (hasConflict) {
            return false;
        }

        if (lowerCaseQuery) {
            return course.name.toLowerCase().includes(lowerCaseQuery) || course.code.toLowerCase().includes(lowerCaseQuery);
        }
        
        return true;
    });
}; 